<div class="table-content">

    <div class="scheduleTable">
        <table>
            <thead>
                <tr>
                    <th>
                        <label class="container checkbox d-flex justify-content-center">
                            <input type="checkbox" [checked]="allSelected" (change)="selectAllRows()">
                            <span class="checkmark"></span>
                        </label>
                    </th>
                    <th>תיאור החופש</th>
                    <th>כיתה</th>
                    <th>מספר כיתה</th>
                    <th>סוג תגבור</th>
                    <th>קייטנה</th>
                    <th>כמות תלמידים</th>
                    <th>סטטוס</th>
                    <th>מתאריך</th>
                    <th class="last-th">עד תאריך</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of pageOfItems" [ngClass]="{ 'row-selected': item._checked == true}">
                    <td class="first-td">
                        <label class="container checkbox d-flex justify-content-center">
                            <input type="checkbox" [(ngModel)]="item._checked" (change)="onSelectRow(item)">
                            <span class="checkmark"></span>
                        </label>
                    </td>
                    <td>{{item.Name}}</td>
                    <td>{{item.Class?.viewValue}}</td>
                    <td>{{item.ClassCode?.value}}</td>
                    <td>{{item.Classification}}</td>
                    <td>{{item.Camp}}</td>
                    <td>{{item.StudentCount}}</td>
                    <td>{{item.Status}}</td>
                    <td>{{item.Date | dateFormat}}</td>
                    <td class="last-th">{{item.DateTo | dateFormat}}</td>
                </tr>
            </tbody>
        </table>
        <div class="tableFooter">
            <jw-pagination [items]="dataSource" (changePage)="onChangePage($event)" [pageSize]="4"></jw-pagination>
        </div>
        <div class="tableEmpty" *ngIf="!pageOfItems || pageOfItems.length == 0">לא נמצאו נתונים</div>

    </div>

    <!-- עיצוב טבלה מותאם למובייל -->

</div>